// import moment from 'moment'
import AOS from "aos";


jQuery(document).ready(function ($) {

  // IMG CACHE BUSTER
  var cacheBuster = Date.now();

  $("img").each(function () {
    var $img = $(this);
    var src = $img.attr("src");

    if (src) {
      var separator = src.indexOf("?") !== -1 ? "&" : "?";
      $img.attr("src", src + separator + "v=" + cacheBuster);
    }
  });


  function addSmoothScrolling() {
    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault();

      var targetId = $(this).attr("href");
      $('html, body').animate({ scrollTop: $(targetId).offset().top }, 'slow');
    });
  }

  addSmoothScrolling();


  AOS.init({
    once: true,
    duration: 600,
    offset: 120,
  });

});